export interface IParseExpertBlocksItem {
  /** Текст */
  description?: string;
  /** Тема оформления */
  theme?: string;
  /** Id */
  id: string;
  /** Полное HTML-тело шаблона */
  outerHtml: string;
  /** Позиция в тексте */
  position: 'top' | 'middle' | 'bottom';
}

export interface IParseExpertBlocks {
  /** HTML-контент */
  html: string;
  /** Коллекция блоков */
  items: IParseExpertBlocksItem[];
}

/**
 * Парсит и вырезает настройки для блоков эксперта
 */
export const parseExpertBlocks = (
  html: string,
  replaceCallback?: (item: IParseExpertBlocksItem, index: number) => string,
): IParseExpertBlocks => {
  const pattern = /<div[^>]*?data-name="expert-block"[^>]*?>[^<]*?<\/div>/gis;
  const items: IParseExpertBlocksItem[] = [];
  let match;

  if (!html) {
    return {
      html: '',
      items,
    };
  }

  let index = 0;
  while ((match = pattern.exec(html))) {
    index = html.indexOf(match[0], index);
    const outerHTML = match[0];

    if (outerHTML) {
      items.push({
        description: (outerHTML.match(/data-description="([^"]*?)"/)?.[1] || '').replace(/\\n/g, '<br/>'),
        theme: outerHTML.match(/data-theme="([^"]*?)"/)?.[1],
        id: `expert-block-${items.length + 1}`,
        outerHtml: outerHTML,
        position: index / html.length < 0.333 ? 'top' : index / html.length < 0.667 ? 'middle' : 'bottom',
      });
    }
  }

  return {
    html: replaceCallback
      ? items.reduce((acc, item, index) => acc.replace(item.outerHtml, replaceCallback(item, index)), html)
      : html,
    items,
  };
};
